module.exports = __webpack_public_path__ + "img/checkApp7.9d1dfd03.png";